import { c as _c } from "react/compiler-runtime";
import { DomainActiveRootStatusEnum } from 'modules/profile/mailing-settings/components/domain-verification/enums/domain-active-root-status-enum';
import { useDomainVerification } from 'modules/profile/mailing-settings/components/domain-verification/hooks/use-domain-verification';
import { getHelpPage } from 'modules/profile/mailing-settings/components/domain-verification/utils/get-help-page';
import { DomainId } from 'modules/profile/mailing-settings/types/mailing-settings-domain-interface';
import { FC } from 'react';
import { Loader } from 'shared/components/loader';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
interface DomainVerificationProps {
  domainId: DomainId;
}
const DomainVerification: FC<DomainVerificationProps> = t0 => {
  const $ = _c(8);
  const {
    domainId
  } = t0;
  const {
    user
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  const {
    status
  } = useDomainVerification(domainId);
  let t1;
  if ($[0] !== status || $[1] !== t || $[2] !== user?.dashboardLocale) {
    t1 = () => {
      switch (status) {
        case DomainActiveRootStatusEnum.verified:
          {
            return <span className="text-green">{t("dashboard.settings.mailing.verification.success")}</span>;
          }
        case DomainActiveRootStatusEnum.missing:
          {
            return <span className="text-danger"><TransLoco t={t} i18nKey="dashboard.settings.mailing.verification.fail" components={{
                a: <a className="primary-link" href={getHelpPage(user?.dashboardLocale)} />
              }} /></span>;
          }
        case null:
          {
            return null;
          }
        default:
          {
            return <div className="flex flex-col items-center gap-1"><Loader /><span>{t("dashboard.settings.mailing.verification.pending")}</span></div>;
          }
      }
    };
    $[0] = status;
    $[1] = t;
    $[2] = user?.dashboardLocale;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getActiveRootStatus = t1;
  let t2;
  if ($[4] !== getActiveRootStatus) {
    t2 = getActiveRootStatus();
    $[4] = getActiveRootStatus;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <div className="flex justify-center">{t2}</div>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default DomainVerification;